import React from "react";
import Menubar from "../Menubar";
import { Container} from "react-bootstrap";

const MaintanceImage = () => {
  return (<>
    <Menubar />
     <Container fluid className="outer-page-content-container" width="90%" style={{ height: "600px", overflow: "visible" }}>
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      {/* <h3>Dashboard View</h3> */}
      <img
        src="/images/maintananceimg.jpg"
        alt="maintananceimg"
        style={{ width: "500px" }}
      />
    </div>
    </Container>
  </>);
};

export default MaintanceImage;